import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceConfigService {

  constructor(private http: HttpClient) { }

  public load(): any{
    if (sessionStorage.hasOwnProperty('serviceconfig')) {
    }
    else {
      return new Promise((resolve, reject) => {
        this.http
          .get("assets/config/serviceconfig.json")
          .pipe(
            map(data => {
              sessionStorage.setItem('serviceconfig', JSON.stringify(data));
              
            }),
            catchError(error => {
              resolve(error);
              return throwError("JSON error");
            })
          )
          .subscribe(firstResponse => {
            resolve(true);
          });
      });
    }
  }

}
